import "./Footer.scss";

export function Footer() {
  return (
    <footer class="site-footer">
      <div class="site-footer__inner">
        <div class="site-footer__brand">
          <h3 class="site-footer__logo">EZ Coupons</h3>
          <p class="site-footer__tagline">
            Your source for local deals across Utah County. Save on restaurants,
            auto, entertainment, health & beauty, and more.
          </p>
        </div>

        <div class="site-footer__links">
          <h4>Quick Links</h4>
          <nav>
            <a href="/">Home</a>
            <a href="/categories">Categories</a>
          </nav>
        </div>

        <div class="site-footer__contact">
          <h4>Contact</h4>
          <p>Utah County, UT</p>
          <p><a href="mailto:contact@ezcoupons.com">contact@ezcoupons.com</a></p>
        </div>
      </div>

      <div class="site-footer__bottom">
        <p>&copy; {new Date().getFullYear()} EZ Coupons. All rights reserved.</p>
      </div>
    </footer>
  );
}
